import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import { getMaterialFiles } from 'src/actions/materialFilesAction';
import {
    STORE_FILES_2,
    STORE_MATERIALFILES,
    STORE_PROGRESS,
    STORE_MATERIAL_PROGRESS,
    STORE_SENDING_INPROGRESS,
    STORE_BRANCH_DATA,
} from '../reducers/fileUpload';

import axios, { AxiosResponse, AxiosError } from 'axios';
// import { push } from 'react-router-redux';
import {
    STORE_ERROR_MESSAGE,
    STORE_ERROR_BAR,
    STORE_SUCCESS_MESSAGE,
    STORE_SUCCESS_BAR,
    STORE_ERROR_FILES_UPLOADED,
    STORE_ERROR_FILES_UPLOADED_MSG,
    STORE_SIGNUP_UPLOAD_ERROR,
    STORE_SIGNUP_UPLOAD_UPDATE,
    // STORE_SUCCESS_FILES_UPLOADED_MSG,
} from 'src/reducers/errors';
import { inputCharacterHandeling } from './supportAction';
import {

    STORE_CUSTOMERMATERIALFILES, // use

} from '../reducers/signupUser';

// export const getOrderDataTable = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

//     // clear all files when component created

//     // const files2: Array<File> = [];
//     // dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//     // const saveMaterial: Array<string> = [];
//     // dispatch({ type: STORE_MATERIAL, saveMaterial } as AnyAction);
//     // const saveTat: Array<string> = [];
//     // dispatch({ type: STORE_TAT, saveTat } as AnyAction);
//     // const saveDesign: Array<string> = [];
//     // dispatch({ type: STORE_DESIGN, saveDesign } as AnyAction);
//     // const saveMsg: Array<string> = [];
//     // dispatch({ type: STORE_MSG, saveMsg } as AnyAction);
//     // const progress: Array<number> = [];
//     // dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//     // const errorBar = false;
//     // dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
//     // const successBar = false;
//     // dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);
//     // const errorMessage = '';
//     // dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);
//     // const successMessage = '';
//     // dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);

//     // const successFileUploadOpen: boolean = false;
//     // dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);
//     // const errorFileUploadedOpen: boolean = false;
//     // dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//     // const successfilemsg = '';
//     // dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
//     // const errorfilemsg = '';
//     // dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);

//     // <------------------------------------------------------------------------------------------------->
//     const sessionid = getState().user.userDetails.s;

//     axios({
//         method: 'post',
//         url: `${getState().environment.API_URL}loadOrderData?listType=tat`,
//         headers: {
//             sessionid: sessionid || ''
//         }
//     }).then(responseOrderdatatat => {
//         const orderDataTat = responseOrderdatatat.data;
//         dispatch({ type: STORE_ORDERDATATAT, orderDataTat } as AnyAction);

//     }).catch(errorOrderdatat => {
//         // ==> console.error('Error ::: TatTypeGet', errorOrderdatat);
//     });

//     // axios({
//     //     method: 'post',
//     //     url: `${getState().environment.API_URL}loadOrderData?listType=desigtyp`,
//     //     headers: {
//     //         sessionid: sessionid || ''
//     //     }
//     // }).then(responseOrderdatadesign => {
//     //     const orderDataDesign = responseOrderdatadesign.data;
//     //     dispatch({ type: STORE_ORDERDATADESIGN, orderDataDesign } as AnyAction);

//     // }).catch(errorOrderdatadesign => {
//     //     // ==> console.error('Error ::: DesignTypeGet', errorOrderdatadesign);
//     // });

//     // axios({
//     //     method: 'post',
//     //     url: `${getState().environment.API_URL}loadOrderData?listType=matetype`,
//     //     headers: {
//     //         sessionid: sessionid || ''
//     //     }
//     // }).then(responseOrderdatamaterial => {
//     //     const orderDataMaterial = responseOrderdatamaterial.data;
//     //     dispatch({ type: STORE_ORDERDATAMATE, orderDataMaterial } as AnyAction);

//     // }).catch(errorOrderdatamaterial => {
//     //     // ==> console.error('Error :::MaterialTypeGet', errorOrderdatamaterial);
//     // });

//     axios({
//         method: 'post',
//         url: `${getState().environment.API_URL}loadOrderData?listType=gdest&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
//         headers: {
//             sessionid: sessionid || ''
//         }
//     }).then(responseOrderdataManufact => {
//         const orderDataManufacturer: ManufacturerData[] = responseOrderdataManufact.data;
//         dispatch({ type: STORE_ORDERDATAMANUFACT, orderDataManufacturer } as AnyAction);

//     }).catch(errorOrderdatamanufact => {
//         // ==> console.error('Error ::: Desitination Get', errorOrderdatamanufact);
//     });

//     axios({
//         method: 'post',
//         url: `${getState().environment.API_URL}loadOrderData?listType=sbuiv&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
//         headers: {
//             sessionid: sessionid || ''
//         }
//     }).then(responseOrderdataSBU => {
//         const orderDataBranch: BranchData[] = responseOrderdataSBU.data;
//         dispatch({ type: STORE_ORDERDATABRANCH, orderDataBranch } as AnyAction);

//     }).catch(errorOrderdataSBU => {
//         // ==> console.error('Error ::: SBUTypeGet', errorOrderdataSBU);
//     });
// };

export const getUTCDateTime = (today: Date) => {
    const hours = `${today.getUTCHours()}`;
    const minutes = `0${today.getUTCMinutes()}`.slice(-2);
    const seconds = `0${today.getUTCSeconds()}`.slice(-2);

    const strTime = `${hours}:${minutes}:${seconds}`;

    const year = today.getUTCFullYear();
    const month = `0${today.getUTCMonth() + 1}`.slice(-2);
    const day = `0${today.getUTCDate()}`.slice(-2);

    const date = `${[day, month, year].join('/')} ${strTime}`;
    return date;
};

export const onFilesChange2 = (filesNew: Array<File>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        console.log(filesNew, 'filesNewfilesNew');
        filesNew.map((file, index) => {
            const x = filesNew[index];
            Object.defineProperties(x, {
                'filename': {
                    value: file.name,
                    writable: true,
                    enumerable: true
                },
                'manufactType': {
                    value: getState().userProfileData.userProfiledata.destination === null ? 'In-House' : getState().userProfileData.userProfiledata.destination,
                    writable: true,
                    enumerable: true
                },
                'designSoftware': {
                    value: getState().userProfileData.userProfiledata.dsoft === null ? '' : getState().userProfileData.userProfiledata.dsoft,
                    writable: true,
                    enumerable: true
                },
                'model': {
                    value: 'N',
                    writable: true,
                    enumerable: true
                },
                'tat': {
                    value: getState().userProfileData.userProfiledata.tat === null ? 'Next Day 7 AM' : getState().userProfileData.userProfiledata.tat,
                    writable: true,
                    enumerable: true
                }

            });
            filesNew[index] = x;
            filesNew.join();
        });

        const filterfile: Array<File> = getState().fileUpload.files2.concat(filesNew);
        console.log('filterfile:', filterfile);
        const stateFiles = getState().fileUpload.files2;
        const filesToAdd = filesNew;

        console.log('State files2:', stateFiles);
        console.log('New files to add (filesNew):', filesToAdd);
        const seen = new Set();
        const files2 = filterfile.filter(el => {
            const duplicate = seen.has(JSON.parse(JSON.stringify(el)).filename);
            seen.add(JSON.parse(JSON.stringify(el)).filename);
            // if (duplicate) {
            //     const warnFileUploadOpen: boolean = true;
            //     dispatch({ type: STORE_WARN_FILES_UPLOADED, warnFileUploadOpen } as AnyAction);
            // }
            return !duplicate;
        });
        if (files2.length > 0) {
            // const successFileUploadOpen = true;
            // const successfilemsg = 'File has been added successfully';
            // dispatch({ type: STORE_SUCCESS_FILES_UPLOADED, successFileUploadOpen } as AnyAction);
            // dispatch({ type: STORE_SUCCESS_FILES_UPLOADED_MSG, successfilemsg } as AnyAction);
            // // ==> console.error(files2);
            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
            filesNew.length = 0;
        }
        return true;
    };
};

//  Onchange values from filestable view part
export const saveMaterialType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'material', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
export const saveTatType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        // const saveTat = [...getState().fileUpload.saveTat];
        // saveTat[index] = value;
        // saveTat.join();
        // dispatch({ type: STORE_TAT, saveTat } as AnyAction);
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'tat', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
export const saveDesignType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'designtype', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
export const saveManufactType = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'manufactType', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
export const saveDesignSoftware = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'designSoftware', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
export const saveOrderModel = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'model', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
export const saveDesignApproval = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const index = parseInt(event.target.value, 10);

        if (event.target.checked === true) {
            const x = files2[index];
            Object.defineProperty(x, 'approval', { value: true, writable: true, enumerable: true });
            files2[index] = x;
            files2.join();
            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        } else {
            const x = files2[index];
            Object.defineProperty(x, 'approval', { value: false, writable: true, enumerable: true });
            files2[index] = x;
            files2.join();
            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        }

        return true;
    };
};
export const saveIsBravo = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const index = parseInt(event.target.value, 10);

        if (event.target.checked === true) {
            const x = files2[index];
            Object.defineProperty(x, 'bravopremium', { value: true, writable: true, enumerable: true });
            files2[index] = x;
            files2.join();
            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        } else {
            const x = files2[index];
            Object.defineProperty(x, 'bravopremium', { value: false, writable: true, enumerable: true });
            files2[index] = x;
            files2.join();
            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        }

        return true;
    };
};
export const saveBranchType = (branchType: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_BRANCH_DATA, branchType } as AnyAction);
        return true;
    };
};
export const saveMessegeOrder = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'msg', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};

export const onUploadAllFiles = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const files2 = [...getState().fileUpload.files2];
    let sending = true;
    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

    const filesCheck = files2.filter((file) => {
        return JSON.parse(JSON.stringify(file)).selected === true;
    });

    if (filesCheck.length === 0) {
        const errorFileUploadedOpen = true;
        const errorfilemsg = `Please select files before clicking 'SEND' button`;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        sending = false;
        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
        return;
    }

    const usercode = getState().user.userDetails.userName;
    const labCode = getState().user.userDetails.labCode;
    const sessionid = getState().user.userDetails.s;
    const businessUnit = getState().fileUpload.branchType;
    const uploadedOrders: Array<string> = [];

    let index = 0;

    for (const file of files2) {

        if (JSON.parse(JSON.stringify(file)).selected === true && JSON.parse(JSON.stringify(file)).uploaded !== true) {

            if (JSON.parse(JSON.stringify(file)).tat !== undefined) {

                const formData = new FormData();
                formData.append('scanfile', file);

                await axios({
                    method: 'post',
                    url: `${getState().environment.API_URL}easyUpload`,
                    data: formData,
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/multipart/form-data',
                        tat: JSON.parse(JSON.stringify(file)).tat || '',
                        material: '',
                        design: '',
                        msg: inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '',
                        customersbu: businessUnit || '',
                        destination: JSON.parse(JSON.stringify(file)).manufactType || '',
                        dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
                        designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
                        servicetype: '0',
                        lab: labCode || '',
                        usercode: usercode || '',
                        sessionid: sessionid || '',
                        requesttime: getUTCDateTime(new Date())
                    },
                    onUploadProgress: (progressEvent) => {

                        const progress = [...getState().fileUpload.progress];
                        const tempProgress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
                        progress[index] = tempProgress;
                        progress.join();
                        // const x = files2[index];
                        // Object.defineProperty(x, 'progress', { value: tempProgress, writable: true, enumerable: true });
                        // files2[index] = x;
                        // files2.join();
                        // dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
                        dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
                        const x = files2[index];
                        Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
                        files2[index] = x;
                        files2.join();
                        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
                    }
                }).then(function (response: AxiosResponse) {
                    const progress = [...getState().fileUpload.progress];
                    if (progress[index] === 100) {

                        uploadedOrders.push(response.data.data.caseno);

                        const x = files2[index];
                        Object.defineProperty(x, 'uploaded', { value: true, writable: true, enumerable: true });
                        files2[index] = x;
                        files2.join();
                        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
                    }
                }).catch(function (error: AxiosError) {

                    const x = files2[index];
                    Object.defineProperty(x, 'uploaded', { value: false, writable: true, enumerable: true });
                    files2[index] = x;
                    files2.join();
                    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

                    const progress = getState().fileUpload.progress;
                    progress[index] = 0;
                    progress.join();
                    dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
                });
            } else {
                const errorFileUploadedOpen = true;
                const errorfilemsg = `Please select ' TAT ' for ${file.name}`;
                dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
                dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            }
        }
        index++;
    }

    const uploadFailed = [...getState().fileUpload.files2].filter((file) => {
        return JSON.parse(JSON.stringify(file)).uploaded === false;
    });

    const uploadCompleted = [...getState().fileUpload.files2].filter((file) => {
        return JSON.parse(JSON.stringify(file)).uploaded === true;
    });

    if (uploadFailed.length > 0) {

        const errorBar = true;
        const errorMessage = `Problem with uploading some files, Please try again`;
        dispatch({ type: STORE_ERROR_BAR, errorBar } as AnyAction);
        dispatch({ type: STORE_ERROR_MESSAGE, errorMessage } as AnyAction);

        sending = false;
        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

        return true;
    }

    if (uploadFailed.length === 0 && uploadCompleted.length > 0) {
        const branchType = 'General';
        dispatch({ type: STORE_BRANCH_DATA, branchType } as AnyAction);

        const successBar = true;
        const successMessage = 'All Orders has been placed successfully';
        dispatch({ type: STORE_SUCCESS_BAR, successBar } as AnyAction);
        dispatch({ type: STORE_SUCCESS_MESSAGE, successMessage } as AnyAction);

        sending = false;
        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

        // // ==> console.error(uploadedOrders);

        axios({
            method: 'post',
            url: `${getState().environment.API_URL}successfulFileuploaded?userName=${getState().user.userDetails.labCode}`,
            data: uploadedOrders
        }).catch(errorOrderdatamaterial => {
            // ==> console.error('Error ::: Mail sent for Orders', errorOrderdatamaterial);
        });

        return true;
    }
    sending = false;
    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
    return true;
};

// comment for 11.07.2025
// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
     
//     const files = [...getState().fileUpload.files2];
//     console.log(files, 'filesfilesfilesfilesfilesfiles');
//     const filesCheck = files.filter((file) => {
//         return JSON.parse(JSON.stringify(file)).selected === true;
//     });
//     // console.log(filesCheck, 'filesCheck');
//     let sending = true;
//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = `Please select files before clicking 'SEND' button`;
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         sending = false;
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;
//     const uploadedOrders: Array<string> = [];

//     files.map((file: File, index: number) => {

//         const files2 = [...getState().fileUpload.files2];

//         if (JSON.parse(JSON.stringify(file)).selected === true && (JSON.parse(JSON.stringify(file)).uploaded === false || JSON.parse(JSON.stringify(file)).uploaded === undefined)) {

//             sending = true;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//             const formData = new FormData();
//             formData.append('scanfile', file);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', file.size.toString());
//             formData.append('uploadedBy', getState().user.userDetails.userName || '');
            
//             axios({
//                 method: 'post',
//                 url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadAync`,
//                 data: formData,
//                 // timeout: 0,
//                 headers: {
//                     'Access-Control-Allow-Origin': '*',
//                     'Content-Type': 'application/multipart/form-data',
//                     tat: JSON.parse(JSON.stringify(file)).tat || '',
//                     material: '',
//                     design: '',
//                     // msg: inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '',
//                     customersbu: businessUnit || '',
//                     destination: JSON.parse(JSON.stringify(file)).manufactType || '',
//                     dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
//                     model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                     modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                     designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                     servicetype: '0',
//                     lab: labCode || '',
//                     usercode: usercode || '',
//                     sessionid: sessionid || '',
//                     requesttime: getUTCDateTime(new Date())
//                 },
//                 onUploadProgress: (progressEvent) => {

//                     const progress = Array.isArray(getState().fileUpload.progress) ? [...getState().fileUpload.progress] : [];
//                     const tempProgress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
//                     progress[index] = tempProgress;
//                     console.log(`File: ${file.name} — Upload Progress: ${tempProgress}%`);
//                     // progress.join();
//                     dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                     const x = files2[index];
//                     Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
//                     files2[index] = x;
//                     // files2.join();
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                     // if (progress[index] === 100) {
//                     //     const fileUploaded = files2[index];
//                     //     Object.defineProperties(fileUploaded, {
//                     //         'uploaded': {
//                     //             value: true,
//                     //             writable: true,
//                     //             enumerable: true
//                     //         }
//                     //     });
//                     //     files2[index] = fileUploaded;
//                     //     files2.join();
//                     //     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                     //     sending = false;
//                     //     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//                     // }
//                 }
//             }).then(function (response: AxiosResponse) {
//                 console.log(response, 'responseTest');
                
//                 uploadedOrders.push(response.data.data.caseno);

//                 sending = true;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 const uploaded = files2[index];
//                 Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
//                 files2[index] = uploaded;
//                 files2.join();
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 // files2 = files2.filter((eachfile) => {
//                 //     if (eachfile.name !== file.name) {
//                 //         progress[index] = 0;
//                 //         progress.join();
//                 //         // ==> console.error(progress, '2');
//                 //         dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
//                 //     }
//                 //     return eachfile.name !== file.name;
//                 // });

//             }).catch(error => {

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 const uploadFailed = files2[index];

//                 Object.defineProperty(uploadFailed, 'uploaded', { value: false, writable: true, enumerable: true });
//                 files2[index] = uploadFailed;
//                 files2.join();
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 const progress = [...getState().fileUpload.progress];
//                 if (progress[index] === 100) {
//                     const fileUploadedError = files2[index];
//                     const errorMsg = error?.response?.data?.msg ?? '';
//                     const isDuplicate = typeof errorMsg === 'string' && errorMsg.includes('ORA-00001');

//                     Object.defineProperties(fileUploadedError, {
//                         'uploaded': {
//                             value: false,
//                             writable: true,
//                             enumerable: true
//                         },
//                         'errorReason': {
//                             // value: (error.response.data.msg).includes('ORA-00001') ? 'Duplicate file' : 'Upload failed',
//                             value: isDuplicate ? 'Duplicate file' : 'Upload failed',
//                             writable: true,
//                             enumerable: true
//                         }
//                     });
//                     files2[index] = fileUploadedError;
//                     files2.join();
//                     // // ==> console.error(files2);
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                     sending = false;
//                     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//                 }

//                 progress[index] = 0;
//                 // progress.join();
//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//             });
//         } else {
//             sending = false;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         }
//         //  else {
//         //     const errorFileUploadedOpen = true;
//         //     const errorfilemsg = `Please select file ${file.name}`;
//         //     dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         //     dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         // }

//     });

//     return true;

// };
// 17.07.2025 === 01:19 PM
// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const files = [...getState().fileUpload.files2];
//     const filesCheck = files.filter((file) => {
//         return JSON.parse(JSON.stringify(file)).selected === true;
//     });
//     let sending = true;
//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = `Please select files before clicking 'SEND' button`;
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         sending = false;
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;
//     const uploadedOrders: Array<string> = [];

//     files.map((file: File, index: number) => {

//         const files2 = [...getState().fileUpload.files2];

//         if (JSON.parse(JSON.stringify(file)).selected === true && (JSON.parse(JSON.stringify(file)).uploaded === false || JSON.parse(JSON.stringify(file)).uploaded === undefined)) {

//             sending = true;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//             const formData = new FormData();
//             formData.append('scanfile', file);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', file.size.toString());
//             formData.append('uploadedBy', getState().user.userDetails.userName || '');

//             const startTime = Date.now(); // Track the start time for calculating total upload time

//             axios({
//                 method: 'post',
//                 url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadAync`,
//                 data: formData,
//                 timeout: 0,  // Make sure there's no timeout limit
//                 headers: {
//                     'Access-Control-Allow-Origin': '*',
//                     'Content-Type': 'application/multipart/form-data',
//                     tat: JSON.parse(JSON.stringify(file)).tat || '',
//                     material: '',
//                     design: '',
//                     customersbu: businessUnit || '',
//                     destination: JSON.parse(JSON.stringify(file)).manufactType || '',
//                     dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
//                     model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                     modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                     designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                     servicetype: '0',
//                     lab: labCode || '',
//                     usercode: usercode || '',
//                     sessionid: sessionid || '',
//                     requesttime: getUTCDateTime(new Date())
//                 },
//                 onUploadProgress: (progressEvent) => {

//                     const progress = Array.isArray(getState().fileUpload.progress) ? [...getState().fileUpload.progress] : [];
//                     const tempProgress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
//                     progress[index] = tempProgress;

//                     // Convert file size to MB
//                     const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
//                     const uploadedSizeInMB = (progressEvent.loaded / (1024 * 1024)).toFixed(2);

//                     // Calculate the upload speed
//                     const elapsedTime = (Date.now() - startTime) / 1000; // Time in seconds
//                     const speed = progressEvent.loaded / elapsedTime; // Speed in bytes per second

//                     // Estimate the remaining time
//                     const remainingBytes = file.size - progressEvent.loaded;
//                     const remainingTime = remainingBytes / speed; // Time in seconds
//                     const remainingMinutes = Math.floor(remainingTime / 60);
//                     const remainingSeconds = Math.floor(remainingTime % 60);

//                     // Calculate total upload time
//                     const totalMinutes = Math.floor(elapsedTime / 60);
//                     const totalSeconds = Math.floor(elapsedTime % 60);

//                     // Log both estimated remaining time and total time
//                     console.log(`File: ${file.name} — Progress: ${tempProgress}% (${uploadedSizeInMB} MB / ${fileSizeInMB} MB) — ` +
//                         `EST Time: ${remainingMinutes}m ${remainingSeconds}s — Upload Time: ${totalMinutes}m ${totalSeconds}s`);

//                     dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                     const x = files2[index];
//                     Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
//                     files2[index] = x;
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 }
//             }).then(function (response: AxiosResponse) {
//                 console.log(response, 'responseTest');
                
//                 uploadedOrders.push(response.data.data.caseno);

//                 sending = true;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 const uploaded = files2[index];
//                 Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
//                 files2[index] = uploaded;
//                 files2.join();
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//             }).catch(error => {

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 const uploadFailed = files2[index];

//                 Object.defineProperty(uploadFailed, 'uploaded', { value: false, writable: true, enumerable: true });
//                 files2[index] = uploadFailed;
//                 files2.join();
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 const progress = [...getState().fileUpload.progress];
//                 if (progress[index] === 100) {
//                     const fileUploadedError = files2[index];
//                     const errorMsg = error?.response?.data?.msg ?? '';
//                     const isDuplicate = typeof errorMsg === 'string' && errorMsg.includes('ORA-00001');

//                     Object.defineProperties(fileUploadedError, {
//                         'uploaded': {
//                             value: false,
//                             writable: true,
//                             enumerable: true
//                         },
//                         'errorReason': {
//                             value: isDuplicate ? 'Duplicate file' : 'Upload failed',
//                             writable: true,
//                             enumerable: true
//                         }
//                     });
//                     files2[index] = fileUploadedError;
//                     files2.join();
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                     sending = false;
//                     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//                 }

//                 progress[index] = 0;
//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//             });
//         } else {
//             sending = false;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         }

//     });

//     return true;
// };

// comment for 24.07.2025

// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const files = [...getState().fileUpload.files2];
//     const filesCheck = files.filter((file) => {
//         return JSON.parse(JSON.stringify(file)).selected === true;
//     });
//     let sending = true;
//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = `Please select files before clicking 'SEND' button`;
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         sending = false;
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;
//     const uploadedOrders: Array<string> = [];

//     files.map((file: File, index: number) => {
//         const files2 = [...getState().fileUpload.files2];

//         if (JSON.parse(JSON.stringify(file)).selected === true && 
//             (JSON.parse(JSON.stringify(file)).uploaded === false || 
//              JSON.parse(JSON.stringify(file)).uploaded === undefined)) {

//             sending = true;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//             const formData = new FormData();
//             formData.append('scanfile', file);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', file.size.toString());
//             formData.append('uploadedBy', getState().user.userDetails.userName || '');

//             const startTime = Date.now();
//             let lastProgressTime = Date.now();

//             // Log upload start
//             console.log(`UPLOAD START - File: ${file.name}, Size: ${(file.size / (1024 * 1024)).toFixed(2)} MB, Index: ${index}`);

//             axios({
//                 method: 'post',
//                 url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadAync`,
//                 data: formData,
//                 // timeout: 0,
//                 headers: {
//                     'Access-Control-Allow-Origin': '*',
//                     'Content-Type': 'application/multipart/form-data',
//                     tat: JSON.parse(JSON.stringify(file)).tat || '',
//                     material: '',
//                     design: '',
//                     customersbu: businessUnit || '',
//                     destination: JSON.parse(JSON.stringify(file)).manufactType || '',
//                     dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
//                     model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                     modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                     designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                     servicetype: '0',
//                     lab: labCode || '',
//                     usercode: usercode || '',
//                     sessionid: sessionid || '',
//                     requesttime: getUTCDateTime(new Date())
//                 },
//                 onUploadProgress: (progressEvent) => {
//                     const currentTime = Date.now();
//                     const progress = Array.isArray(getState().fileUpload.progress) ? [...getState().fileUpload.progress] : [];
//                     const tempProgress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
//                     progress[index] = tempProgress;

//                     // Check for stalled upload (no progress for more than 30 seconds)
//                     if (currentTime - lastProgressTime > 30000) {
//                         console.warn(`UPLOAD STALLED - File: ${file.name}, Progress: ${tempProgress}%, Stalled for: ${Math.round((currentTime - lastProgressTime) / 1000)}s`);
//                     }
//                     lastProgressTime = currentTime;

//                     // Convert file size to MB
//                     const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
//                     const uploadedSizeInMB = (progressEvent.loaded / (1024 * 1024)).toFixed(2);

//                     // Calculate the upload speed
//                     const elapsedTime = (Date.now() - startTime) / 1000;
//                     const speed = progressEvent.loaded / elapsedTime;

//                     // Estimate the remaining time
//                     const remainingBytes = file.size - progressEvent.loaded;
//                     const remainingTime = remainingBytes / speed;
//                     const remainingMinutes = Math.floor(remainingTime / 60);
//                     const remainingSeconds = Math.floor(remainingTime % 60);

//                     // Calculate total upload time
//                     const totalMinutes = Math.floor(elapsedTime / 60);
//                     const totalSeconds = Math.floor(elapsedTime % 60);

//                     // Enhanced progress logging
//                     console.log(`UPLOAD PROGRESS - File: ${file.name} — Progress: ${tempProgress}% (${uploadedSizeInMB} MB / ${fileSizeInMB} MB) —
//                     Speed: ${(speed / (1024 * 1024)).toFixed(2)} MB/s —
//                     EST Time: ${remainingMinutes}m ${remainingSeconds}s — Upload Time: ${totalMinutes}m ${totalSeconds}s`);

//                     dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                     const x = files2[index];
//                     Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
//                     files2[index] = x;
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 }
//             }).then(function (response: AxiosResponse) {
//                 const uploadTime = (Date.now() - startTime) / 1000;
//                 console.log(`UPLOAD SUCCESS - File: ${file.name}, Total Time: ${Math.round(uploadTime)}s, Response:`, response.data);
                
//                 uploadedOrders.push(response.data.data.caseno);

//                 sending = true;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 const uploaded = files2[index];
//                 Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
//                 files2[index] = uploaded;
//                 files2.join();
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//             }).catch(error => {
//                 const uploadTime = (Date.now() - startTime) / 1000;
                
//                 // COMPREHENSIVE ERROR LOGGING
//                 console.group(`UPLOAD ERROR - File: ${file.name}`);
//                 console.log(`Upload Time Before Error: ${Math.round(uploadTime)}s`);
//                 console.log(`File Size: ${(file.size / (1024 * 1024)).toFixed(2)} MB`);
//                 console.log(`File Index: ${index}`);
                
//                 // Log different types of errors
//                 if (error.code === 'ECONNABORTED') {
//                     console.error('ERROR TYPE: Request Timeout');
//                 } else if (error.code === 'NETWORK_ERROR') {
//                     console.error('ERROR TYPE: Network Error');
//                 } else if (error.response) {
//                     console.error('ERROR TYPE: Server Response Error');
//                     console.log('Response Status:', error.response.status);
//                     console.log('Response Headers:', error.response.headers);
//                     console.log('Response Data:', error.response.data);
//                 } else if (error.request) {
//                     console.error('ERROR TYPE: Request Error (No Response)');
//                     console.log('Request Config:', error.config);
//                 } else {
//                     console.error('ERROR TYPE: Unknown Error');
//                 }
                
//                 console.error('Full Error Object:', error);
//                 console.error('Error Message:', error.message);
//                 console.error('Error Stack:', error.stack);
//                 console.groupEnd();

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 const uploadFailed = files2[index];
//                 Object.defineProperty(uploadFailed, 'uploaded', { value: false, writable: true, enumerable: true });
//                 files2[index] = uploadFailed;
//                 files2.join();
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 const progress = [...getState().fileUpload.progress];
//                 if (progress[index] === 100) {
//                     const fileUploadedError = files2[index];
//                     const errorMsg = error?.response?.data?.msg ?? '';
//                     const isDuplicate = typeof errorMsg === 'string' && errorMsg.includes('ORA-00001');

//                     // Enhanced error reason determination
//                     let errorReason = 'Upload failed';
//                     if (isDuplicate) {
//                         errorReason = 'Duplicate file';
//                     } else if (error.code === 'ECONNABORTED') {
//                         errorReason = 'Request timeout';
//                     } else if (error.code === 'NETWORK_ERROR') {
//                         errorReason = 'Network error';
//                     } else if (error.response?.status === 413) {
//                         errorReason = 'File too large';
//                     } else if (error.response?.status === 500) {
//                         errorReason = 'Server error';
//                     } else if (error.response?.status === 400) {
//                         errorReason = 'Bad request';
//                     } else if (error.response?.data?.msg) {
//                         errorReason = error.response.data.msg;
//                     }

//                     console.log(`ERROR REASON DETERMINED: ${errorReason}`);

//                     Object.defineProperties(fileUploadedError, {
//                         'uploaded': {
//                             value: false,
//                             writable: true,
//                             enumerable: true
//                         },
//                         'errorReason': {
//                             value: errorReason,
//                             writable: true,
//                             enumerable: true
//                         }
//                     });
//                     files2[index] = fileUploadedError;
//                     files2.join();
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                     sending = false;
//                     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//                 }

//                 progress[index] = 0;
//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                 sending = false;
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//             });
//         } else {
//             sending = false;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         }
//     });

//     return true;
// };

// const CHUNK_SIZE = 1024 * 1024; // 1MB

// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const files = [...getState().fileUpload.files2];
//     const filesCheck = files.filter(file => JSON.parse(JSON.stringify(file)).selected === true);

//     const sending = true;
//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: true } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: `Please select files before clicking 'SEND' button` } as AnyAction);
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;

//     filesCheck.forEach(async (file: File, index: number) => {
//         const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
//         const fileId = `${file.name}-${file.size}-${Date.now()}`;

//         for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
//             const start = chunkIndex * CHUNK_SIZE;
//             const end = Math.min(start + CHUNK_SIZE, file.size);
//             const chunk = file.slice(start, end);

//             const formData = new FormData();
//             formData.append('chunk', chunk);
//             formData.append('fileName', file.name);
//             formData.append('chunkIndex', chunkIndex.toString());
//             formData.append('totalChunks', totalChunks.toString());
//             formData.append('fileId', fileId);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', file.size.toString());
//             formData.append('uploadedBy', usercode || '');

//             try {
//                 await axios.post(`${getState().environment.ORDER_UPLOAD_URL}easyUploadChunk`, formData, {
//                     headers: {
//                         tat: JSON.parse(JSON.stringify(file)).tat || '',
//                         customersbu: businessUnit || '',
//                         destination: JSON.parse(JSON.stringify(file)).manufactType || '',
//                         dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
//                         model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                         modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                         designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                         servicetype: '0',
//                         lab: labCode || '',
//                         usercode: usercode || '',
//                         sessionid: sessionid || '',
//                     },
//                     onUploadProgress: (progressEvent) => {
//                         const progress = [...getState().fileUpload.progress];
//                         const chunkProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                         const totalProgress = Math.round(((chunkIndex + chunkProgress / 100) / totalChunks) * 100);
//                         progress[index] = totalProgress;
//                         dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
//                     }
//                 });

//                 if (chunkIndex === totalChunks - 1) {
//                     const files2 = [...getState().fileUpload.files2];
//                     const uploaded = files2[index];
//                     Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
//                     files2[index] = uploaded;
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 }

//             } catch (error) {
//                 console.error('Chunk upload failed', error);
//                 const progress = [...getState().fileUpload.progress];
//                 progress[index] = 0;
//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                 const files2 = [...getState().fileUpload.files2];
//                 const failed = files2[index];
//                 Object.defineProperty(failed, 'uploaded', { value: false, writable: true, enumerable: true });
//                 files2[index] = failed;
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 break;
//             }
//         }

//         dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//     });

//     return true;
// };

// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const files = [...getState().fileUpload.files2];
//     const filesCheck = files.filter(file => JSON.parse(JSON.stringify(file)).selected === true);
//     const sending = true;

//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: true } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: `Please select files before clicking 'SEND' button` } as AnyAction);
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;

//     filesCheck.forEach(async (file: File, index: number) => {
//         const fileSize = file.size;
//         const chunkSize = Math.ceil(fileSize / 10); // Split into 10 chunks
//         const totalChunks = Math.ceil(fileSize / chunkSize);
//         const fileId = `${file.name}-${file.size}-${Date.now()}`;
//         const files2 = [...getState().fileUpload.files2];

//         for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
//             const start = chunkIndex * chunkSize;
//             const end = Math.min(start + chunkSize, fileSize);
//             const chunk = file.slice(start, end);

//             const formData = new FormData();
//             formData.append('chunk', chunk);
//             formData.append('fileName', file.name);
//             formData.append('chunkIndex', chunkIndex.toString());
//             formData.append('totalChunks', totalChunks.toString());
//             formData.append('fileId', fileId);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', fileSize.toString());
//             formData.append('uploadedBy', usercode || '');

//             try {
//                 await axios.post(`${getState().environment.ORDER_UPLOAD_URL}easyUploadChunk`, formData, {
//                     headers: {
//                         'tat': JSON.parse(JSON.stringify(file)).tat || '',
//                         'customersbu': businessUnit || '',
//                         'destination': JSON.parse(JSON.stringify(file)).manufactType || '',
//                         'dsoft': JSON.parse(JSON.stringify(file)).designSoftware || '',
//                         'model': JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                         'modelonly': JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                         'designapproval': JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                         'servicetype': '0',
//                         'lab': labCode || '',
//                         'usercode': usercode || '',
//                         'sessionid': sessionid || '',
//                     },
//                     onUploadProgress: (progressEvent) => {
//                         const progress = [...getState().fileUpload.progress];
//                         const chunkProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                         const totalProgress = Math.round(((chunkIndex + chunkProgress / 100) / totalChunks) * 100);
//                         progress[index] = totalProgress;
//                         dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                         // mark as uploading
//                         const x = files2[index];
//                         Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
//                         files2[index] = x;
//                         dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                     }
//                 });

//                 if (chunkIndex === totalChunks - 1) {
//                     // Last chunk successfully uploaded
//                     const uploaded = files2[index];
//                     Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
//                     files2[index] = uploaded;
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 }

//             } catch (error) {
//                 console.error(`Chunk upload failed for file: ${file.name}`, error);

//                 const failed = files2[index];
//                 Object.defineProperty(failed, 'uploaded', { value: false, writable: true, enumerable: true });
//                 Object.defineProperty(failed, 'errorReason', {
//                     value: error?.response?.data?.msg?.includes('ORA-00001') ? 'Duplicate file' : 'Upload failed',
//                     writable: true,
//                     enumerable: true
//                 });
//                 files2[index] = failed;

//                 const progress = [...getState().fileUpload.progress];
//                 progress[index] = 0;

//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 break;
//             }
//         }

//         dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//     });

//     return true;
// };
// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const files = [...getState().fileUpload.files2];
//     const filesCheck = files.filter(file => JSON.parse(JSON.stringify(file)).selected === true);
//     const uploadedOrders: Array<string> = [];

//     const sending = true;
//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen: true } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg: `Please select files before clicking 'SEND' button` } as AnyAction);
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;

//     filesCheck.forEach(async (file: File, index: number) => {
//         const fileSize = file.size;
//         const chunkSize = Math.ceil(fileSize / 10); 
//         const totalChunks = Math.ceil(fileSize / chunkSize);
//         const fileId = `${file.name}-${file.size}-${Date.now()}`;
//         const files2 = [...getState().fileUpload.files2];

//         for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
//             const start = chunkIndex * chunkSize;
//             const end = Math.min(start + chunkSize, fileSize);
//             const chunk = file.slice(start, end);

//             const formData = new FormData();
//             formData.append('chunk', chunk);
//             formData.append('fileName', file.name);
//             formData.append('chunkIndex', chunkIndex.toString());
//             formData.append('totalChunks', totalChunks.toString());
//             formData.append('fileId', fileId);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', fileSize.toString());
//             formData.append('uploadedBy', getState().user.userDetails.userName || '');

//             try {
//                 const response = await axios.post(`${getState().environment.ORDER_UPLOAD_URL}easyUploadChunk`, formData, {
//                     headers: {
//                         'Access-Control-Allow-Origin': '*',
//                         'Content-Type': 'application/multipart/form-data',
//                         tat: JSON.parse(JSON.stringify(file)).tat || '',
//                         material: '',
//                         design: '',
//                         customersbu: businessUnit || '',
//                         destination: JSON.parse(JSON.stringify(file)).manufactType || '',
//                         dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
//                         model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                         modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                         designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                         servicetype: '0',
//                         lab: labCode || '',
//                         usercode: usercode || '',
//                         sessionid: sessionid || '',
//                         requesttime: getUTCDateTime(new Date())
//                     },
//                     onUploadProgress: (progressEvent) => {
//                         const progress = [...getState().fileUpload.progress];
//                         const chunkProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                         const totalProgress = Math.round(((chunkIndex + chunkProgress / 100) / totalChunks) * 100);
//                         progress[index] = totalProgress;
//                         dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                         const x = files2[index];
//                         Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
//                         files2[index] = x;
//                         dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                     }
//                 });

//                 if (chunkIndex === totalChunks - 1) {
//                     const uploaded = files2[index];
//                     Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
//                     files2[index] = uploaded;
//                     dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                     console.log('Final chunk upload response:', response.data);
//                     if (response?.data?.data?.caseno) {
//                         uploadedOrders.push(response.data.data.caseno); 
//                         console.log('Uploaded order pushed:', response.data.data.caseno);
//                     }

//                     dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//                 }

//             } catch (error) {
//                 const failed = files2[index];
//                 Object.defineProperty(failed, 'uploaded', { value: false, writable: true, enumerable: true });
//                 Object.defineProperty(failed, 'errorReason', {
//                     value: error?.response?.data?.msg?.includes('ORA-00001') ? 'Duplicate file' : 'Upload failed',
//                     writable: true,
//                     enumerable: true
//                 });
//                 files2[index] = failed;

//                 const progress = [...getState().fileUpload.progress];
//                 progress[index] = 0;

//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                 dispatch({ type: STORE_SENDING_INPROGRESS, sending: false } as AnyAction);
//                 break;
//             }
//         }
//     });

//     return true;
// };

export const onUploadAllFilesAsync1 = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const files = [...getState().fileUpload.files2];

    const filesCheck = files.filter((file) => {
        return JSON.parse(JSON.stringify(file)).selected === true;
    });

    let sending = true;
    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

    if (filesCheck.length === 0) {
        const errorFileUploadedOpen = true;
        const errorfilemsg = `Please select files before clicking 'SEND' button`;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        sending = false;
        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
        return;
    }

    const usercode = getState().user.userDetails.userName;
    const labCode = getState().user.userDetails.labCode;
    const sessionid = getState().user.userDetails.s;
    const businessUnit = getState().fileUpload.branchType;
    const uploadedOrders: Array<string> = [];

    for (let index = 0; index < files.length; index++) {
        const file = files[index];
        const files2 = [...getState().fileUpload.files2];

        if (
            JSON.parse(JSON.stringify(file)).selected === true &&
            (JSON.parse(JSON.stringify(file)).uploaded === false ||
                JSON.parse(JSON.stringify(file)).uploaded === undefined)
        ) {
            sending = true;
            dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

            const formData = new FormData();
            formData.append('scanfile', file);
            formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
            formData.append('appType', 'b2b');
            formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
            formData.append('filesize', file.size.toString());
            formData.append('uploadedBy', getState().user.userDetails.userName || '');

            // --- Retry logic for large files ---
            const MAX_RETRIES = 3;
            let attempt = 0;
            let uploadSuccess = false;

            while (attempt < MAX_RETRIES && !uploadSuccess) {
                try {
                    await axios({
                        method: 'post',
                        url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadAsync`,
                        data: formData,
                        timeout: 2 * 60 * 60 * 1000, // 2 hours
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/multipart/form-data',
                            tat: JSON.parse(JSON.stringify(file)).tat || '',
                            material: '',
                            design: '',
                            customersbu: businessUnit || '',
                            destination: JSON.parse(JSON.stringify(file)).manufactType || '',
                            dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
                            model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
                            modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
                            designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
                            servicetype: '0',
                            lab: labCode || '',
                            usercode: usercode || '',
                            sessionid: sessionid || '',
                            requesttime: getUTCDateTime(new Date())
                        },
                        onUploadProgress: (progressEvent) => {
                            const progress = Array.isArray(getState().fileUpload.progress)
                                ? [...getState().fileUpload.progress]
                                : [];
                            const tempProgress: number =
                                Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
                            progress[index] = tempProgress;
                            dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

                            const x = files2[index];
                            Object.defineProperty(x, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
                            files2[index] = x;
                            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
                        }
                    });

                    // Success logic
                    uploadedOrders.push(file.name); // or response.data.data.caseno if needed

                    sending = true;
                    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

                    const uploaded = files2[index];
                    Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
                    files2[index] = uploaded;
                    files2.join();
                    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

                    sending = false;
                    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

                    uploadSuccess = true;
                } catch (error: unknown) {
                    attempt++;
                    sending = false;
                    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

                    const uploadFailed = files2[index];
                    Object.defineProperty(uploadFailed, 'uploaded', { value: false, writable: true, enumerable: true });
                    files2[index] = uploadFailed;
                    files2.join();
                    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

                    const progress = [...getState().fileUpload.progress];
                    progress[index] = 0;
                    dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

                    if (attempt < MAX_RETRIES) {
                        // Wait before retrying
                        await new Promise(res => setTimeout(res, 2000));
                    }
                }
            }
        } else {
            sending = false;
            dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
        }
    }

    return true;
};

const getOptimalChunkSize = (fileSize: number) => {
  // File size constants
  const MB = 1024 * 1024;
  const GB = 1024 * 1024 * 1024;

  // Chunk size boundaries (aggressive for good network)
  let chunkSize;

  if (fileSize <= 20 * MB) {
    // Small files (5-20MB): 5MB chunks for fast completion
    chunkSize = 5 * MB;
  } else if (fileSize <= 100 * MB) {
    // Medium files (20-100MB): 10MB chunks (your current setting)
    chunkSize = 10 * MB;
  } else if (fileSize <= 300 * MB) {
    // Large files (100-300MB): 20MB chunks for efficiency
    chunkSize = 20 * MB;
  } else if (fileSize <= 1 * GB) {
    // Very large files (300MB-1GB): 30MB chunks
    chunkSize = 30 * MB;
  } else if (fileSize <= 2 * GB) {
    // Huge files (1-2GB): 40MB chunks
    chunkSize = 40 * MB;
  } else {
    // Massive files (2-4GB): 50MB chunks for maximum throughput
    chunkSize = 50 * MB;
  }

  // Safety constraints
  const MIN_CHUNK_SIZE = 5 * MB;   // Never go below 5MB
  const MAX_CHUNK_SIZE = 50 * MB;  // Never exceed 50MB
  const MAX_CHUNKS = 500;          // Keep chunk count reasonable

  // Apply constraints
  chunkSize = Math.max(MIN_CHUNK_SIZE, Math.min(MAX_CHUNK_SIZE, chunkSize));

  // Ensure we don't create too many chunks
  const minChunkSizeForFile = Math.ceil(fileSize / MAX_CHUNKS);
  chunkSize = Math.max(chunkSize, minChunkSizeForFile);

  return chunkSize;
};

// --- helper to split file into chunks ---
function createFileChunks(file: File, chunkSize: number = 5 * 1024 * 1024): Blob[] {
    const chunks: Blob[] = [];
    let start = 0;
    while (start < file.size) {
        const end = Math.min(start + chunkSize, file.size);
        chunks.push(file.slice(start, end));
        start = end;
    }
    return chunks;
}

export const onUploadAllFilesAsync = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const files = [...getState().fileUpload.files2];

    const filesCheck = files.filter((file) => {
        return JSON.parse(JSON.stringify(file)).selected === true;
    });

    let sending = true;
    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

    if (filesCheck.length === 0) {
        const errorFileUploadedOpen = true;
        const errorfilemsg = `Please select files before clicking 'SEND' button`;
        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        sending = false;
        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
        return;
    }

    const usercode = getState().user.userDetails.userName;
    const labCode = getState().user.userDetails.labCode;
    const sessionid = getState().user.userDetails.s;
    const businessUnit = getState().fileUpload.branchType;
    const uploadedOrders: Array<string> = [];

    for (let index = 0; index < files.length; index++) {
        const file = files[index];
        const files2 = [...getState().fileUpload.files2];

        if (
            JSON.parse(JSON.stringify(file)).selected === true &&
            (JSON.parse(JSON.stringify(file)).uploaded === false ||
                JSON.parse(JSON.stringify(file)).uploaded === undefined)
        ) {
            sending = true;
            dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
            // --- Determine optimal chunk size ---
            const optimalChunkSize = getOptimalChunkSize(file.size);
            console.log(`Uploading file: ${file.name}, Size: ${file.size} bytes, Using chunk size: ${optimalChunkSize} bytes`);
            // --- Split into chunks ---
            const chunks = createFileChunks(file, optimalChunkSize);
            const totalChunks = chunks.length;
            const uploadId = `${file.name}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

            // --- Retry logic for entire file upload ---
            const MAX_RETRIES = 3;
            let attempt = 0;
            let uploadSuccess = false;

            while (attempt < MAX_RETRIES && !uploadSuccess) {
                try {
                    // Mark file as uploading
                    const uploadingFile = files2[index];
                    Object.defineProperty(uploadingFile, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
                    files2[index] = uploadingFile;
                    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

                    // Upload all chunks for this file
                    let allChunksSuccess = true;
                    
                    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
                        const chunk = chunks[chunkIndex];
                        const formData = new FormData();
                        
                        formData.append('scanfile', chunk, file.name);
                        formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
                        formData.append('appType', 'b2b');
                        formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
                        formData.append('filesize', file.size.toString());
                        formData.append('uploadedBy', usercode || '');
                        formData.append('drPreferences', JSON.parse(JSON.stringify(file)).drPreferences || '');
                        formData.append('bookingId', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).bookingId) || '');

                        // --- Chunk-level retry logic ---
                        const MAX_CHUNK_RETRIES = 2;
                        let chunkAttempt = 0;
                        let chunkSuccess = false;

                        while (chunkAttempt < MAX_CHUNK_RETRIES && !chunkSuccess) {
                            try {
                                await axios({
                                    method: 'post',
                                    url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadChunkAsync`,
                                    data: formData,
                                    timeout: 2 * 60 * 60 * 1000, // 2 hours
                                    headers: {
                                        'Access-Control-Allow-Origin': '*',
                                        'Content-Type': 'multipart/form-data',
                                        tat: JSON.parse(JSON.stringify(file)).tat || '',
                                        material: '',
                                        design: '',
                                        customersbu: businessUnit || '',
                                        destination: JSON.parse(JSON.stringify(file)).manufactType || '',
                                        dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
                                        model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
                                        modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
                                        designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
                                        servicetype: '0',
                                        lab: labCode || '',
                                        usercode: usercode || '',
                                        sessionid: sessionid || '',
                                        requesttime: getUTCDateTime(new Date()),
                                        // --- Chunk metadata headers ---
                                        'x-chunk-index': chunkIndex.toString(),
                                        'x-total-chunks': totalChunks.toString(),
                                        'x-upload-id': uploadId,
                                        'x-file-name': file.name
                                    },
                                    onUploadProgress: (progressEvent) => {
                                        const progress = Array.isArray(getState().fileUpload.progress)
                                            ? [...getState().fileUpload.progress]
                                            : [];
                                        
                                        const chunkProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
                                        // Overall progress = (completed chunks + current chunk progress) / total chunks
                                        const overall = Math.min(100, Math.round(((chunkIndex + chunkProgress / 100) / totalChunks) * 100));
                                        
                                        progress[index] = overall;
                                        dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

                                        // Update file status to show uploading
                                        const currentFiles2 = [...getState().fileUpload.files2];
                                        const currentFile = currentFiles2[index];
                                        Object.defineProperty(currentFile, 'uploaded', { value: 'uploading', writable: true, enumerable: true });
                                        currentFiles2[index] = currentFile;
                                        dispatch({ type: STORE_FILES_2, files2: currentFiles2 } as AnyAction);
                                    }
                                });

                                chunkSuccess = true;
                            } catch (chunkError: unknown) {
                                chunkAttempt++;
                                console.error(`Chunk ${chunkIndex + 1}/${totalChunks} failed (attempt ${chunkAttempt}):`, chunkError);
                                
                                if (chunkAttempt < MAX_CHUNK_RETRIES) {
                                    // Wait before retrying chunk
                                    await new Promise(res => setTimeout(res, 1000));
                                }
                            }
                        }

                        if (!chunkSuccess) {
                            allChunksSuccess = false;
                            break; // Exit chunk loop if a chunk fails
                        }
                    }

                    if (allChunksSuccess) {
                        // All chunks uploaded successfully
                        uploadedOrders.push(file.name);

                        sending = true;
                        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

                        const uploaded = files2[index];
                        Object.defineProperty(uploaded, 'uploaded', { value: true, writable: true, enumerable: true });
                        files2[index] = uploaded;
                        files2.join();
                        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

                        sending = false;
                        dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

                        uploadSuccess = true;
                    } else {
                        throw new Error('One or more chunks failed to upload');
                    }

                } catch (error: unknown) {
                    attempt++;
                    console.error(`File upload attempt ${attempt} failed:`, error);
                    
                    sending = false;
                    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

                    // Reset progress
                    const progress = [...getState().fileUpload.progress];
                    progress[index] = 0;
                    dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

                    if (attempt < MAX_RETRIES) {
                        // Wait before retrying entire file
                        await new Promise(res => setTimeout(res, 2000));
                        console.log(`Retrying file upload (attempt ${attempt + 1}/${MAX_RETRIES})...`);
                    } else {
                        // Final failure - mark file as failed
                        const uploadFailed = files2[index];
                        Object.defineProperty(uploadFailed, 'uploaded', { value: false, writable: true, enumerable: true });
                        files2[index] = uploadFailed;
                        files2.join();
                        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

                        // Show error to user
                        const errorFileUploadedOpen = true;
                        const errorfilemsg = `Upload failed for file: ${file.name}. Please try again.`;
                        dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
                        dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
                    }
                }
            }
        } else {
            sending = false;
            dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
        }
    }

    // Final state cleanup
    sending = false;
    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

    return true;
};

// export const onUploadAllFilesAsync = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
//     const files = [...getState().fileUpload.files2];
//     const maxFileSize = 5 * 1024 * 1024 * 1024; // 5GB limit

//     const filesCheck = files.filter((file) => {
//         return JSON.parse(JSON.stringify(file)).selected === true;
//     });

//     let sending = true;
//     dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//     if (filesCheck.length === 0) {
//         const errorFileUploadedOpen = true;
//         const errorfilemsg = `Please select files before clicking 'SEND' button`;
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
//         dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
//         sending = false;
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//         return;
//     }

//     const usercode = getState().user.userDetails.userName;
//     const labCode = getState().user.userDetails.labCode;
//     const sessionid = getState().user.userDetails.s;
//     const businessUnit = getState().fileUpload.branchType;
//     const uploadedOrders: Array<string> = [];

//     // Process files sequentially to avoid overwhelming the server
//     const uploadFile = async (file: File, index: number) => {
//         const files2 = [...getState().fileUpload.files2];

//         if (file.size > maxFileSize) {
//             const fileError = files2[index];
//             Object.defineProperties(fileError, {
//                 'uploaded': { value: false, writable: true, enumerable: true },
//                 'errorReason': { value: 'File size exceeds 5GB limit', writable: true, enumerable: true }
//             });
//             files2[index] = fileError;
//             dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//             return;
//         }

//         if (JSON.parse(JSON.stringify(file)).selected === true && 
//             (JSON.parse(JSON.stringify(file)).uploaded === false || 
//              JSON.parse(JSON.stringify(file)).uploaded === undefined)) {

//             sending = true;
//             dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);

//             const formData = new FormData();
//             formData.append('scanfile', file);
//             formData.append('msg', inputCharacterHandeling(JSON.parse(JSON.stringify(file)).msg) || '');
//             formData.append('appType', 'b2b');
//             formData.append('bravo', JSON.parse(JSON.stringify(file)).bravopremium === true ? '1' : '0');
//             formData.append('filesize', file.size.toString());
//             formData.append('uploadedBy', getState().user.userDetails.userName || '');

//             try {
//                 const response = await axios({
//                     method: 'post',
//                     url: `${getState().environment.ORDER_UPLOAD_URL}easyUploadAync`,
//                     data: formData,
//                     timeout: 600000, // 10 minutes
//                     maxContentLength: Infinity, // Allow unlimited content length
//                     headers: {
//                         'Access-Control-Allow-Origin': '*',
//                         'Content-Type': 'multipart/form-data',
//                         'Content-Length': file.size.toString(),
//                         tat: JSON.parse(JSON.stringify(file)).tat || '',
//                         material: '',
//                         design: '',
//                         customersbu: businessUnit || '',
//                         destination: JSON.parse(JSON.stringify(file)).manufactType || '',
//                         dsoft: JSON.parse(JSON.stringify(file)).designSoftware || '',
//                         model: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : JSON.parse(JSON.stringify(file)).model || 'N',
//                         modelonly: JSON.parse(JSON.stringify(file)).model === 'S' ? 'Y' : 'N',
//                         designapproval: JSON.parse(JSON.stringify(file)).approval === true ? '1' : '0',
//                         servicetype: '0',
//                         lab: labCode || '',
//                         usercode: usercode || '',
//                         sessionid: sessionid || '',
//                         requesttime: getUTCDateTime(new Date())
//                     },
//                     onUploadProgress: (progressEvent) => {
//                         const progress = Array.isArray(getState().fileUpload.progress) ? 
//                             [...getState().fileUpload.progress] : [];
//                         const tempProgress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
//                         progress[index] = tempProgress;
//                         dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

//                         const x = files2[index];
//                         Object.defineProperty(x, 'uploaded', { 
//                             value: 'uploading', 
//                             writable: true, 
//                             enumerable: true 
//                         });
//                         files2[index] = x;
//                         dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
//                     }
//                 });

//                 uploadedOrders.push(response.data.data.caseno);

//                 const uploaded = files2[index];
//                 Object.defineProperty(uploaded, 'uploaded', { 
//                     value: true, 
//                     writable: true, 
//                     enumerable: true 
//                 });
//                 files2[index] = uploaded;
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//             } catch (error) {
//                 const uploadFailed = files2[index];
//                 const errorMessage = error.code === 'ECONNABORTED' ? 
//                     'Upload timeout - Please try again' :
//                     (error.response?.data?.msg?.includes('ORA-00001') ? 
//                         'Duplicate file' : 'Upload failed');

//                 Object.defineProperties(uploadFailed, {
//                     'uploaded': { value: false, writable: true, enumerable: true },
//                     'errorReason': { value: errorMessage, writable: true, enumerable: true }
//                 });
//                 files2[index] = uploadFailed;
//                 dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

//                 const progress = [...getState().fileUpload.progress];
//                 progress[index] = 0;
//                 dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
//             }
//         }
        
//         sending = false;
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//     };

//     // Upload files sequentially
//     const uploadFiles = async () => {
//         for (let i = 0; i < files.length; i++) {
//             await uploadFile(files[i], i);
//         }
//     };

//     uploadFiles().catch(error => {
//         console.error('Upload process failed:', error);
//         sending = false;
//         dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
//     });

//     return true;
// };
export const onUploadType = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (getState().environment.ASYNC_UPLOAD === 'true') {
        onUploadAllFilesAsync(dispatch, getState);
    } else {
        onUploadAllFiles(dispatch, getState);
    }
};

export const onRefreshStatus = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const files2: Array<File> = [...getState().fileUpload.files2];
    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
    const progress: Array<number> = [...getState().fileUpload.progress];
    dispatch({ type: STORE_PROGRESS, progress } as AnyAction);

    return true;
};

export const onUploadConfirmation = (uploadedOrders: string[]) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        axios({
            method: 'post',
            url: `${getState().environment.API_URL}successfulFileuploaded?userName=${getState().user.userDetails.labCode}`,
            data: uploadedOrders
        }).catch(errorOrderdatamaterial => {
            // ==> console.error('Error ::: Mail sent for Orders', errorOrderdatamaterial);
        });
    };
};

//  Editing table structure of filestable
export const deleteRowbyId = (event: React.ChangeEvent<{ value: string }>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        const files2 = [...getState().fileUpload.files2];
        const progress = [...getState().fileUpload.progress];

        const filesindex = files2.map((e) => {
            return JSON.parse(JSON.stringify(e)).filename;
        }).indexOf(event.currentTarget.value as string);

        if (filesindex >= 0) {
            files2.splice(filesindex, 1);
            dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
            progress.splice(filesindex, 1);
            dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
        }
    };
};

export const onClearAllUploaded = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const progress = getState().fileUpload.progress;
    const files = [...getState().fileUpload.files2];

    const files2 = files.filter((file, index) => {
        if (JSON.parse(JSON.stringify(file)).uploaded === true) {
            progress[index] = 0;
            progress.join();
        }
        return JSON.parse(JSON.stringify(file)).uploaded !== true;
    });

    if (files.length > files2.length) {
        const selectAll = document.querySelector('#selectAll') as HTMLInputElement;
        if (selectAll !== null && selectAll.checked === true) {
            selectAll.click();
        }
    }

    dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
    dispatch({ type: STORE_FILES_2, files2 } as AnyAction);

    return true;
};
export const onClearAllFiles = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (getState().fileUpload.files2 > []) {
        const files2: Array<File> = [];
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        const progress: Array<number> = [];
        dispatch({ type: STORE_PROGRESS, progress } as AnyAction);
    }
    const selectAll = document.querySelector('#selectAll') as HTMLInputElement;
    if (selectAll !== null && selectAll.checked === true) {
        selectAll.click();
    }
    const sending = false;
    dispatch({ type: STORE_SENDING_INPROGRESS, sending } as AnyAction);
    return true;
};

export const onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];

        const index = parseInt(event.target.value, 10);
        if (JSON.parse(JSON.stringify(files2[index])).tat !== undefined) {

            if (event.target.checked === true) {
                const x = files2[index];
                Object.defineProperty(x, 'selected', { value: true, writable: true, enumerable: true });
                files2[index] = x;
                files2.join();
                dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
            } else {
                const x = files2[index];
                Object.defineProperty(x, 'selected', { value: false, writable: true, enumerable: true });
                files2[index] = x;
                files2.join();
                dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
            }
        } else {
            const errorFileUploadedOpen = true;
            const errorfilemsg = `Please select ' TAT ' for ${files2[index].name}`;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
        }

    };
};

export const onSelectAllFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files: Array<File> = getState().fileUpload.files2;

        files.map((file, index) => {
            const namefile = `#${JSON.parse(JSON.stringify(file)).id}`;
            const selectCheck = document.querySelector(namefile) as HTMLInputElement;
            if (selectCheck !== null && selectCheck.checked === false && event.target.checked === true) {
                selectCheck.click();
            } else if (selectCheck !== null && selectCheck.checked === true && event.target.checked === false) {
                selectCheck.click();
            } else if (selectCheck !== null && selectCheck.checked === true && event.target.checked === true) {
                return;
            }

        });
    };
};

export const doMaterialFileUpload = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const files = getState().signupUser.customermaterialfiles || '';
    const custname = getState().userProfileData.userProfiledata.custcode;
    // files.map((file: File, index: number) => {
    const formData = new FormData();
    formData.append('uploadedfile', files);
    formData.append('custname', custname || '');

    axios({
        method: 'post',
        url: `${getState().environment.SIGNUP_UPLOAD_URL}UploadSignupFiles`,
        data: formData,
        onUploadProgress: (progressEvent) => {

            const materialprogress: number = Math.round((progressEvent.loaded * 100) / progressEvent.total) || 0;
            const materialfiles = 'uploading';
            dispatch({ type: STORE_MATERIAL_PROGRESS, materialprogress } as AnyAction);
            dispatch({ type: STORE_MATERIALFILES, materialfiles } as AnyAction);

        }
    }).then(function (response: AxiosResponse) {
        if (response) {
            const materialfiles = 'uploaded';
            dispatch({ type: STORE_MATERIALFILES, materialfiles } as AnyAction);
            const data = {
                custcode: '',
                custfile: '',
                custname: ''
            };
            data.custcode = getState().userProfileData.userProfiledata.custcode || '';
            data.custfile = getState().signupUser.customermaterialfiles?.name || '';
            data.custname = getState().userProfileData.userProfiledata.custname || '';
            axios({
                method: 'post',
                url: `${getState().environment.API_URL}saveMaterialFileName`,
                data: data,

            }).then(function (response2: AxiosResponse) {
                if (response2) {
                    dispatch(getMaterialFiles);
                    const customermaterialfiles = '';
                    dispatch({ type: STORE_CUSTOMERMATERIALFILES, customermaterialfiles } as AnyAction);
                }

            }).catch(error => {
                const errorBar = true;
                // const errorMessage = error.response.data.error ? error.response.data.error.message : 'Error';
                const errorMessage = 'Error';
                dispatch({ type: STORE_SIGNUP_UPLOAD_ERROR, errorMessage } as AnyAction);
                dispatch({ type: STORE_SIGNUP_UPLOAD_UPDATE, errorBar } as AnyAction);

            });
        }

    }).catch(error => {
        const materialfiles = 'uploadfailed';
        // Dispatch an action to update the store with the modified file
        dispatch({ type: STORE_MATERIALFILES, materialfiles } as AnyAction);
        const errorBar = true;
        // const errorMessage = error.response.data.error ? error.response.data.error.message : 'Error';
        const errorMessage = 'Error';
        dispatch({ type: STORE_SIGNUP_UPLOAD_ERROR, errorMessage } as AnyAction);
        dispatch({ type: STORE_SIGNUP_UPLOAD_UPDATE, errorBar } as AnyAction);
    });

    return true;
};

export const clearMaterialFiles = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const customermaterialfiles = '';
    dispatch({ type: STORE_CUSTOMERMATERIALFILES, customermaterialfiles } as AnyAction);
    const materialfiles = '';
    dispatch({ type: STORE_MATERIALFILES, materialfiles } as AnyAction);
    const materialprogress = 0;
    dispatch({ type: STORE_MATERIAL_PROGRESS, materialprogress } as AnyAction);

    return true;
};

export const saveDrPreferences = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'drPreferences', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};
 
export const saveBookingId = (value: string, index: number) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        const files2 = [...getState().fileUpload.files2];
        const x = files2[index];
        Object.defineProperty(x, 'bookingId', { value: value, writable: true, enumerable: true });
        files2[index] = x;
        files2.join();
        dispatch({ type: STORE_FILES_2, files2 } as AnyAction);
        return true;
    };
};



// WEBPACK FOOTER //
// ./src/actions/fileuploadAction.ts